import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export interface CopyTextProps {
  value: string;
  label: string;
  className?: string;
}

export const CopyText: React.FC<CopyTextProps> = ({ className, label, value }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="flex items-center gap-2 max-w-[140px]">
      <span className={cn('truncate text-xs text-muted-foreground', className)}>
        {label}
      </span>

      <Button
        className={cn(
          copied ? 'text-green-500' : 'text-blue-500',
          'transition-colors duration-150',
        )}
        icon={copied ? 'check-check' : 'copy'}
        onClick={handleCopy}
        variant="ghost"
        size="icon"
      />
    </div>
  );
};
